<template>
  <section class="proposal-page__section branding-case">
    <article class="proposal-page__cut branding-case__black-cut">
      <div class="pp-container --is-narrow">
        <header class="proposal-page__section-heading">
          <h2 class="proposal-page__section-title">{{ data.content.case.title }}</h2>
          <p class="proposal-page__section-description">{{ data.content.case.description }}</p>
        </header>

        <div class="branding-case__spotlight">
          <div class="branding-case__schuber" data-aos="fade-up" data-aos-duration="600">
            <div class="branding-case__logo" :style="`background-color: ${data.background};`">
              <img :src="`${data.logo.sizes.medium}?format=png`" alt="Schuber Logo">
            </div>

            <img src="@/assets/images/proposal-page/schuber.png" class="branding-case__mask">
          </div>
        </div>
      </div>
    </article>

    <article class="proposal-page__cut branding-case__gray-cut">
      <div class="pp-container">
        <ul class="branding-case__features">
          <li class="branding-case__feature">
            <div v-html="data.content.case.features.angebot_branding_case_feature1_icon"></div>

            <h3 class="branding-case__feature-title">{{ data.content.case.features.angebot_branding_case_feature1_title }}</h3>
            <p class="branding-case__feature-description">{{ data.content.case.features.angebot_branding_case_feature1_description }}</p>
          </li>

          <li class="branding-case__feature">
            <div v-html="data.content.case.features.angebot_branding_case_feature2_icon"></div>

            <h3 class="branding-case__feature-title">{{ data.content.case.features.angebot_branding_case_feature2_title }}</h3>
            <p class="branding-case__feature-description">{{ data.content.case.features.angebot_branding_case_feature2_description }}</p>
          </li>

          <li class="branding-case__feature">
            <div v-html="data.content.case.features.angebot_branding_case_feature3_icon"></div>

            <h3 class="branding-case__feature-title">{{ data.content.case.features.angebot_branding_case_feature3_title }}</h3>
            <p class="branding-case__feature-description">{{ data.content.case.features.angebot_branding_case_feature3_description }}</p>
          </li>
        </ul>
      </div>
    </article>
  </section>
</template>

<script>
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'BrandingCase',
  mixins: [helperMixin],
  props: ['data']
};
</script>

<style lang="scss" scoped>
/**
 * Branding Case
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Branding Case section
 * @since 2022-09-12
**/

.proposal-page__section-description {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

$component: 'branding-case';

.#{$component} {
  color: #d4d8de;

  &__black-cut {
    background: radial-gradient(#212B36, #0f151b 100%);
  }

  &__gray-cut {
    @include padding-top(map-get($spacers, 4) * 3 !important);
    background: $ink;
  }

  // Spotlight
  &__spotlight {
    overflow: hidden;
    @include padding-top(map-get($spacers, 4));
  }

  &__schuber {
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 70%;
    height: auto;
    aspect-ratio: 1 / 1;
    margin: 0 auto;
    @include margin-bottom(- map-get($spacers, 6) * 2);
    pointer-events: none;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    @include imageRendering;
  }

  &__logo {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 50%;
    aspect-ratio: 1 / 1;
    pointer-events: none;

    img {
      width: 80%;
      pointer-events: none;
      @include imageRendering;
    }
  }

  // Features
  &__features {
    @include unlist;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__feature {
    flex: 0 0 28%;

    svg {
      @include rfs(3.4rem, width);
      color: #d4d8de;
    }
  }

  &__feature-title {
    @include margin-top(map-get($spacers, 3));
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(map-get($proposal-page, 'font-size-lg'));
    line-height: 130%;
  }

  &__feature-description {
    margin: 0;
    font-weight: $font-weight-lighter;
  }

  &__germany-text-mask {
    font-weight: $font-weight-bolder;
    // text-shadow: 1px 1px 4px lighten(#1C1C1C, 10%);
    background: linear-gradient(to right, #616161, #9a4756, #b7ac83);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-md')) {
    @at-root .proposal-page__section-heading {
      @include margin-bottom(map-get($spacers, 4) !important);
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-sm')) {
    &__features {
      @include margin-bottom(- map-get($spacers, 4) * 3)
    }

    &__feature {
      flex: 0 0 48%;
      @include margin-bottom(map-get($spacers, 4) * 3);
    }

    &__schuber {
      width: 80%;
    }

    @at-root .proposal-page__section-description {
      width: 100%;
    }
  }

  // ——————————————————————————————
  // XXS
  // ——————————————————————————————
  @media (max-width: map-get($proposal-page, 'viewport-xs')) {
    &__feature {
      flex: 0 0 100%;
      @include margin-bottom(map-get($spacers, 4) * 4);
    }
  }

  // ——————————————————————————————
  // XS
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-xs')) and (max-width: map-get($proposal-page, 'viewport-sm')) {

  }

  // ——————————————————————————————
  // SM
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-sm')) and (max-width: map-get($proposal-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // MD
  // ——————————————————————————————
  @media (min-width: map-get($proposal-page, 'viewport-md')) and (max-width: map-get($proposal-page, 'viewport-lg')) {
  }
}
</style>
